export default {
  Newsfeed: {
    Content: 'Trao đổi trong bài',
    AddImage: 'Thêm hình ảnh',
    All: 'Tất cả {likeCount}'
  },
  Comment: {
    TimeMinutesComment: '{diffDate} phút trước',
    TimeHourCommet: '{diffDate} giờ trước',
    TimeDateComment: '{diffDate} ngày trước',
    TimeWeekComment: '{diffDate} tuần trước',
    TimeMonthComment: '{diffDate} tháng trước',
    TimeYearComment: '{diffDate} năm trước',

    Reply: 'Trả lời',
    Liked: 'Đã thích',
    PlaceHolderContent: 'Nhập nội dung trao đổi',
    AddImage: 'Thêm ảnh',
    LikeCount: '{likeCount} lượt thích',
    Update: 'Sửa bình luận',
    Delete: 'Xóa',
    DeleteNotify: 'Bạn có chắc muốn xóa trao đổi này?',
    Cancel: 'Không',
    JustComment: 'Vừa xong',
    ContentEmpty: 'Bạn vui lòng nhập nội dung bình luận',
    UsersLike: '{likeCount} người bày tỏ cảm xúc',
    LoadMoreComment: 'Xem thêm bình luận'
  },
  Emoji: {
    Like: 'Thích',
    Love: 'Yêu thích',
    Haha: 'Haha',
    Wow: 'Ngạc nhiên'
  }
}
